import { LPBaseURL } from '@mais-retorno-front/components/utm-button/enum';

export enum DEFAULT_ROUTES {
  sheetFunds = '/fundo',
  sheetCrypto = '/crypto',
  rankingFund = '/melhores-fundos',
  searchFund = '/busca-fundos',
  comparisonFund = '/comparacao-fundos',
  dashboard = '/app/dashboard',
  fundTracker = '/app/rastreador-fundos',
  assetsComparison = '/app/comparador-ativos',
  portfolio = '/app/carteira',
  bookmarkFund = '/app/fundo-favorito',
  bookmarkComparison = '/app/comparacao-favorito',
  bookmarkContent = '/app/conteudo-favorito',
  userProfile = '/app/meu-perfil',
  userConnections = '/app/conecoes',
  updatePaymentMethod = '/app/meu-perfil/editar-pagamento',
  userSubscription = '/app/minhas-assinaturas',
  userSubscriptionHistory = '/app/minhas-assinaturas/historico',
  incomeSimulation = '/app/simulador-rendimentos',
  createIncomeSimulation = '/app/simulador-rendimentos/novo',
  editUserProfile = '/app/meu-perfil/editar',
  filterFunds = '/lista-fundos-investimentos',
  managerListFund = '/gestores',
  adminListFunds = '/administradores',
  podcast = '/portal/retornocast',
  videos = '/videos',
  glossary = '/portal/glossario-financas-investimentos',
  terms = '/portal/termos',
  financialControlWorksheet = '/portal/planilhas/planilha-de-controle-financeiro-e-investimentos',
  fundsReportWorksheet = '/portal/planilhas/relatorio-de-fundos',
  privatePensionTest = '/portal/form/20',
  profileInvestorTest = '/portal/form/10',
  books = '/portal/livros',
  course = '/portal/cursos',
  categories = '/portal/noticias',
  tags = '/portal/tudo-sobre',
  investmentFundsCategory = '/fundos-de-investimentos',
  realEstateCategory = '/fundos-imobiliarios',
  variableIncome = '/renda-variavel',
  fixedIncome = '/renda-fixa',
  economy = '/economia',
  financialMarket = '/mercado-financeiro',
  login = '/login',
  recoveryPassword = '/recuperar-senha',
  simplifyCourse = '/portal/cursos/descomplicando-a-bolsa-de-valores',
  howInvestCourse = '/portal/cursos/como-investir-melhores-fundos',
  realEstateFundsCourse = '/portal/cursos/dominando-fundos-imobiliarios',
  specialistBook = '/portal/livros/livro-investidor-especialista',
  basicGuideFIBook = '/portal/livros/guia-basico-fiis-vale-a-pena-investir',
  stocksBook = '/portal/livros/12-pilares-que-todo-investidor-de-acoes-precisa-saber',
  authorPage = '/portal/autor',
  portal = '/portal/',
  latestNews = '/portal/ultimas-noticias',
  unifiedSearch = '/busca',
  nextjsApiBase = '/api/nextjs',
  evergreenHome = '/portal/mais-conteudo',
  redirectParamName = 'callbackUrl',
  treasuryDirectList = '/lista-tesouro-direto',
  publicTitleList = '/lista-titulos-publicos',
  treasuryDirect = '/tesouro-direto',
  publicTitle = '/titulos-publicos',
  stocksList = '/lista-acoes',
  fiiList = '/lista-fii',
  bdrList = '/lista-bdr',
  etfList = '/lista-etf',
  fiagroList = '/lista-fiagro',
  fipList = '/lista-fip',
  indexesList = '/lista-indices',
  fiInfrapList = '/lista-fi-infra',
  debenturesList = '/lista-debentures',
  list = '/lista-ativos',
  portalBaseUrl = '/portal',
  feedbackApp = 'https://feedback.maisretorno.com/',
  privacyPolicy = 'https://sobre.maisretorno.com/portal-privacidade',
  applicationTerms = '/termos-de-uso',
  about = 'https://sobre.maisretorno.com',
  workWithUs = 'https://sobre.maisretorno.com/vagas',
  contact = 'https://sobre.maisretorno.com/contato',
  retornoAdsLp = 'https://lp.maisretorno.com/retorno-ads',
  retornoPrimeWhiteLabel = 'https://lp.maisretorno.com/white-label',
  retornoPrimeAPI = 'https://lp.maisretorno.com/api',
  retornoProApp = 'https://pro.maisretorno.com',
  retornoProAppCreateIncomeSimulation = 'https://pro.maisretorno.com/simulador-carteira/novo',
  retornoProWalletSimulation = 'https://pro.maisretorno.com/simulador-carteira',
  retornoProAppSubscriptions = 'https://pro.maisretorno.com/ajustes/assinaturas',
  youtubeChannel = 'https://www.youtube.com/maisretorno?sub_confirmation=1',
  facebookPage = 'https://www.facebook.com/maisretorno',
  twitterPage = 'https://twitter.com/mais_retorno',
  linkedinPage = 'https://www.linkedin.com/company/maisretorno/',
  tiktokPage = 'https://www.tiktok.com/@mais_retorno',
  telegramChannel = 'https://t.me/maisretorno',
  instagramPage = 'https://www.instagram.com/mais_retorno/',
  checkout = 'https://checkout.maisretorno.com',
  helpCenter = '/app/central-de-ajuda',
  unauthorized = '/403',
}

const BASE_PRIME = 'https://lp.maisretorno.com/retorno-prime';

export const PRIME_TRACKING_ROUTES = {
  CTANavbarProduct: `${BASE_PRIME}?utm_source=site&utm_medium=menu&utm_content=cta_menu_produto`,
  CTANavbar: `${BASE_PRIME}?utm_source=site&utm_medium=menu&utm_content=ctamenu`,
  CTAComparisonModalAssets: `${BASE_PRIME}?utm_source=site&utm_medium=comparador_ativos&utm_content=modal_10_ativos`,
  CTAComparisonFundsModalAssets: `${BASE_PRIME}?utm_source=site&utm_medium=comparador_fundos&utm_content=modal_10_ativos`,
  CTADuplicateAssetSimulation: `${BASE_PRIME}?utm_source=site&utm_medium=simulador&utm_content=duplicar_simulacao`,
  CTASimulationCustomPeriod: `${BASE_PRIME}?utm_source=site&utm_medium=simulador&utm_content=periodo_customizado`,
  CTAScreenerMoreFilters: `${BASE_PRIME}?utm_source=site&utm_medium=screener&utm_content=mais_filtros`,
  CTAComparisonRemoveAsset: `${BASE_PRIME}?utm_source=site&utm_medium=comparador_ativos&utm_content=remover_ativo`,
  CTASimulationCreateMany: `${BASE_PRIME}?utm_source=site&utm_medium=simulador&utm_content=mais_simulacoes`,
  CTASimulationComparison: `${BASE_PRIME}?utm_source=site&utm_medium=simulador&utm_content=comparacao_simulacoes`,
  CTADashboardPortfolio: `${BASE_PRIME}?utm_source=site&utm_medium=dashboard&utm_content=cta_portfolio`,
};

export const PRO_TRACKING_ROUTES = {
  CTANavbarProduct: `${LPBaseURL.PRO}?utm_source=site&utm_medium=menu&utm_content=cta_menu_produto`,
};
